/**
 * Core module - Framework-agnostic foundations
 *
 * Pure logic that works in any JavaScript environment:
 * - Browser (React, vanilla JS)
 * - Node.js (server, build tools)
 * - Edge (Vercel Edge Functions)
 *
 * Zero runtime dependencies beyond Zod.
 */

// Types
export type {
  FormTracking,
  FormPayload,
  FormSubmissionMetadata,
  ClientDataContextProps,
  ClientData,
  SubmitFormResult,
  GatewaySubmitPayload,
  OnServerLog,
  AnalyticsFormName,
  FormCloseDetail,
  ModalFormCloseSource,
  EasModalVariant,
  ModalDisplayFrequency,
  EasModalTriggerConfig,
  AutomaticModalTriggerConfig,
  EasModalSidePanelContent,
} from './types';

// Constants
// biome-ignore lint/performance/noBarrelFile: Core package entrypoint intentionally defines the public API surface.
export { EAS_MODAL_TEMPLATE_LABELS } from './types';

// Validation utilities
export {
  isValidEmail,
  createEmailSchema,
  createRequiredStringSchema,
} from './validation';

// API payload building
export { buildPayload } from './api';
